module.exports = __webpack_public_path__ + "static/media/account_create_success.66fac504.svg";